import { useSetAtom } from 'jotai'
import { useManualTaskPreviewToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskPreviewToolkit'
import { TaskInput } from '../../types'
import { ContractReviewHeader } from '../ContractReviewHeader'
import { Button, Flex } from '@sequencehq/core-components'
import { manualTaskProcessorTaskIdAtom } from 'Automations/watchtower/atoms'

export const ContractReviewPreviewHeaderContent = ({
  taskId
}: {
  taskId: string
}) => {
  const setProcessorTaskId = useSetAtom(manualTaskProcessorTaskIdAtom)

  const { manualTask } = useManualTaskPreviewToolkit<TaskInput>({ taskId })

  if (!manualTask?.input) return null

  return (
    <Flex justifyContent="space-between">
      <ContractReviewHeader
        customer={manualTask.input.customer}
        contractName={manualTask.input.contract?.name}
      />

      <Flex gap="8px">
        <Button
          variant="primary"
          data-testid="contractReview.preview.reviewContract"
          onClick={() => {
            setProcessorTaskId(manualTask.id)
          }}
        >
          Review contract
        </Button>
      </Flex>
    </Flex>
  )
}
